(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaDeleteController',CampagnaDeleteController);

    CampagnaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagna'];

    function CampagnaDeleteController($uibModalInstance, entity, Campagna) {
        var vm = this;

        vm.campagna = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagna.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
